<template>
  <div class="ui buttons fluid" :class="buttonsClasses" data-wd="inSearchType">
    <button
      class="ui button"
      :class="{ active: type === 'book' }"
      @click="changeType('book')"
    >
      <i class="book icon" />
      {{ $tc("words.book", 2) }}
    </button>
    <button
      class="ui button"
      :class="{ active: type === 'memo' }"
      @click="changeType('memo')"
    >
      <i class="sticky note icon" />
      {{ $tc("words.memo", 2) }}
    </button>
  </div>
</template>

<script>
export default {
  props: {
    inScreen: { type: Boolean, default: false },
    type: { type: String, default: 'book' }
  },
  computed: {
    buttonsClasses () {
      return this.inScreen ? ['inverted', 'grey', 'huge'] : ['large']
    }
  },
  methods: {
    changeType (type) {
      this.$emit('change', type)
    }
  }
}
</script>
